import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const FIELDS = [
  { key: "instagram", label: "Lien Instagram", ph: "https://instagram.com/votre_compte" },
  { key: "tiktok", label: "Lien TikTok", ph: "https://tiktok.com/@votre_compte" },
  { key: "contact_email", label: "Email de contact", ph: "contact@luxeoryvea.com" },
  { key: "announcement", label: "Bandeau d'annonce", ph: "Livraison offerte…" },
  { key: "promo_code", label: "Code promo", ph: "ORYVEA10" },
  { key: "promo_percent", label: "Réduction (%)", type: "number" },
  { key: "shipping_days", label: "Délai de livraison", ph: "2 à 4 jours ouvrés" },
  { key: "limited_edition_total", label: "Stock édition limitée (total)", type: "number" },
  { key: "low_stock_threshold", label: "Seuil \"Bientôt épuisé\"", type: "number" },
];

export function AdminSettings() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)).catch(() => {}); }, []);

  const save = async () => {
    setBusy(true);
    try {
      const payload = { ...s };
      payload.promo_percent = Number(payload.promo_percent) || 0;
      payload.limited_edition_total = Number(payload.limited_edition_total) || 0;
      payload.low_stock_threshold = Number(payload.low_stock_threshold) || 0;
      const { data } = await api.put("/admin/settings", payload);
      setS(data);
      toast.success("Paramètres enregistrés");
    } catch { toast.error("Erreur lors de l'enregistrement"); }
    finally { setBusy(false); }
  };

  if (!s) return <p className="text-sm" style={{ color: "var(--lo-muted)" }}>Chargement…</p>;

  return (
    <div className="card-lux p-7 max-w-2xl" data-testid="admin-settings">
      <p className="overline mb-6">Contenu & paramètres du site</p>
      <div className="grid sm:grid-cols-2 gap-5">
        {FIELDS.map((f) => (
          <label key={f.key} className={f.key === "announcement" ? "sm:col-span-2 block" : "block"}>
            <span className="overline block mb-2" style={{ fontSize: "0.6rem" }}>{f.label}</span>
            <input
              type={f.type || "text"}
              value={s[f.key] ?? ""}
              placeholder={f.ph || ""}
              onChange={(e) => setS({ ...s, [f.key]: e.target.value })}
              className="w-full bg-transparent border-b py-2 text-sm outline-none"
              style={{ borderColor: "var(--lo-border)" }}
              data-testid={`settings-${f.key}`}
            />
          </label>
        ))}
      </div>
      <button onClick={save} disabled={busy} className="btn-primary h-11 px-8 mt-8 disabled:opacity-50" data-testid="settings-save">
        {busy ? "…" : "Enregistrer"}
      </button>
    </div>
  );
}
